<template>
  <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100" elevation="4" height="150"
    rounded max-width="600" width="100%" mb="6">
    <div>
      <div class="text-h5 font-weight-medium pa-2">
        DIRECCIÓN GENERAL LOGÍSTICA<br>UNIDAD DE MATERIAL BÉLICO
      </div>
      <p class="text-body-2 mb-4">
        Registro clasificado de armas de fuego, municiones y explosivos de uso Militar
      </p>
    </div>
  </v-sheet>

  <v-form @submit="submitForm">
    <v-container>
      <h2>Registro de Número de Pistola</h2>

      <v-text-field v-model="busqueda" label="Buscar por carnet de identidad" required></v-text-field>
      <v-btn @click="buscarOficialEjercito()">Buscar</v-btn>
      
    </v-container>
  </v-form>


  <v-card
    class="mx-auto"
    max-width="300"
  >
    <v-list density="compact">
      <v-list-subheader>REPORTS</v-list-subheader>

      <v-list-item
        v-for="(item, i) in items"
        :key="i"
        :value="item"
        color="primary"
      >
        <template v-slot:prepend>
          <v-icon :icon="item.icon"></v-icon>
        </template>

        <v-list-item-title v-text="item.text"></v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>

</template>

<script>
import { defineComponent } from 'vue';
import EjercitoOficial from "@/services/Ejercitoficial";
export default defineComponent({
  name: "RegistroArmas",
  data() {
    var registros;
    const nombres = [];
    return {
      selectedBackend: null,
      backends: ['Backend 1', 'Backend 2', 'Backend 3'], // Aquí puedes reemplazar con los nombres de backend reales obtenidos desde el backend
      busqueda: '',
      numero_pistola:'',
      registros,
      nombres,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
    };
  },
  methods: {
    submitForm() {
      // Aquí puedes realizar las acciones correspondientes al guardar el número de pistola con el backend seleccionado
      console.log('Backend seleccionado:', this.busqueda);
      console.log('Número de pistola:', this.busqueda);
      // Por ejemplo, puedes enviar los datos al backend para su procesamiento
    },
  },


  async mounted() {

    const ejercito_oficial = new EjercitoOficial();
    this.registros = await ejercito_oficial.listOficialesEjercito();
 
  }

});
</script>
